import type { MeetingDetailDTO, MeetingListItemDTO, Paginated, TranscriptSegmentDTO } from '@copilot/shared';
import { api, downloadFile, type Query } from './client';
import type { MeetingPatch } from './types';

export const meetingsApi = {
  list: (query: Query) => api<Paginated<MeetingListItemDTO>>('/meetings', { query }),
  exportCsv: (query: Query) => downloadFile('/meetings/export.csv', 'meetings.csv', query),
  get: (id: string) => api<MeetingDetailDTO>(`/meetings/${encodeURIComponent(id)}`),
  transcript: (id: string) => api<TranscriptSegmentDTO[]>(`/meetings/${encodeURIComponent(id)}/transcript`),
  exportMarkdown: (id: string) =>
    downloadFile(`/meetings/${encodeURIComponent(id)}/export`, `meeting-${id}.md`, { format: 'md' }),
  recordPdfExport: (id: string) =>
    api<void>(`/meetings/${encodeURIComponent(id)}/audit`, { method: 'POST', body: { action: 'export_pdf' } }),
  patch: (id: string, body: MeetingPatch) =>
    api<MeetingDetailDTO>(`/meetings/${encodeURIComponent(id)}`, { method: 'PATCH', body }),
  remove: (id: string) => api<void>(`/meetings/${encodeURIComponent(id)}`, { method: 'DELETE' }),
};
